
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Industry = () => {
  return (
    <SettingsMetaData propertyName={"Industry_Appoinments"} viewPropertyName={"Industry"} />
  );
};
export default Industry;
